export default __webpack_public_path__ + "static/media/shonit rbc.c2968e5a.png";